<template>
  <div>
    <ur-system v-if="showContent">
      <auth-layout v-if="isLoginPage" />
      <layout v-else />
      <snackbar-message />
    </ur-system>
    <page-loader v-if="getPageLoader" />
    <auto-logout />
  </div>
</template>

<script>
import Layout from "./components/layouts/Layout.vue";
import AuthLayout from "./components/layouts/AuthLayout.vue";
import PageLoader from "./sisPageLoader.vue";
import { mapActions, mapGetters } from "vuex";
import SnackbarMessage from "./components/sisSnackbarMessage.vue";
import UtilVue from "@/mixins/sisUtilIMS";
export default {
  name: "App",
  mixins: [UtilVue],
  data() {
    return {
      showContent: false,
    };
  },
  components: {
    Layout,
    AuthLayout,
    PageLoader,
    SnackbarMessage,
  },
  computed: {
    ...mapGetters(["getPageLoader"]),
    isLoginPage() {
      return this.$route.meta.isAuthPage;
    },
  },
  methods: {
    ...mapActions(["fetchUserToken", "fetchUserInfo", "generateUserAuthToken"]),
    getLoggedInUserInfo() {
      this.fetchUserInfo()
        .then((response) => {
          this.showContent = true;
          this.setLoader(false);
        })
        .catch((err) => {
          this.showContent = true;
          this.setSnackbar({
            active: true,
            msg: "Something went wrong",
          });
          this.setLoader(false);
        });
    },
  },
  async created() {
    // this.setLoader(true);
    // this.fetchUserToken()
    //   .then((response) => {
    //     localStorage.setItem("token", response.data.access_token);
    //     localStorage.setItem("refresh_token", response.data.refresh_token);
    //     this.getLoggedInUserInfo();
    //     this.setLoader(false);
    //   })
    //   .catch((err) => {
    //     this.showContent = true;
    //     this.setLoader(false);
    //     this.setSnackbar({
    //       active: true,
    //       msg: "Something went wrong",
    //     });
    //   });
    // this.getLoggedInUserInfo();
  },
};
</script>

<style lang="less">
.body-wrapper {
  display: flex;
  height: calc(100vh - 74px);
  clear: both;
}
.sidebar-area {
  display: inline-block;
}
.ur-system {
  min-height: auto !important;
}
</style>
